import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/empty-screen.svg'


const _withScopeId = n => (_pushScopeId("data-v-426a990e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "empty-screen md:!tw-pt-[24px] md:!tw-mt-0" }
const _hoisted_2 = { class: "empty-screen__inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-screen__image md:!tw-ml-0 md:!tw-mb-[24px]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = { class: "empty-screen__header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Start your new project at lightning speed.", -1))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"empty-screen__content\" data-v-426a990e><div class=\"empty-screen__content-item\" data-v-426a990e><div class=\"mdi mdi-check-circle\" data-v-426a990e></div><p data-v-426a990e><strong data-v-426a990e>Dispute protection</strong> as standard</p></div><div class=\"empty-screen__content-item\" data-v-426a990e><div class=\"mdi mdi-check-circle\" data-v-426a990e></div><p data-v-426a990e>Deposits secured <strong data-v-426a990e>in Escrow</strong></p></div><div class=\"empty-screen__content-item\" data-v-426a990e><div class=\"mdi mdi-check-circle\" data-v-426a990e></div><p data-v-426a990e>Verified trade contractors <strong data-v-426a990e>in your local area</strong></p></div></div>", 1)
const _hoisted_7 = { class: "empty-screen__footer" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectListEmptyState',
  props: {
  allowButton: Boolean,
  headingText: String,
},
  emits: ["openNewProject"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const onClickNewProject = () => {
  emits("openNewProject");
};
const props = __props;
console.log("propssss", props);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, "You currently don’t have any " + _toDisplayString(props.headingText) + " projects", 1),
        _hoisted_5
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (props.allowButton)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "button button-purple",
              onClick: onClickNewProject,
              block: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Start a new project ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})